<template lang="pug">
  .custom-input
    .custom-input__input
      input.input(
        v-bind:class="{ 'input_full' : full }"
        v-on:keyup="keyUpInput"
        v-model="localSuggest"
      )
    custom-autocomplete(
      v-if="showAutocomplete"
      @close="showAutocomplete = false"
      :show-autocomplete="showAutocomplete"
      :suggetion-list="suggetionList"
      :on-click-suggetion="onClickSuggetion"
    )
</template>

<script>
import {mapActions} from "vuex";

import CustomAutocomplete from "./CustomAutocomplete.vue";

export default {
  name: "CustomInput",
  components: {
    CustomAutocomplete
  },
  props: {
    full: {
      type: Boolean,
      default: false
    },
    suggest: {
      type: String,
      default: ""
    },
    suggestKey: {
      type: String,
      default: ""
    },
    additionalKey: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: "suggest/address"
    },
    paramsBoost: {
      type: String,
      default: ""
    },
    suggestType: {
      type: String,
      default: ""
    },
    locationBoost: {
      type: Object,
      default: () => ({})
    },
    onChangeInput: {
      type: Function,
      default: () => {}
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      interval: null,
      showAutocomplete: false,
      types: {
        region: {
          from_bound: "region",
          to_bound: "region"
        },
        area: {
          from_bound: "area",
          to_bound: "area"
        },
        city: {
          from_bound: "city",
          to_bound: "settlement"
        },
        street: {
          from_bound: "street",
          to_bound: "street"
        },
        house: {
          from_bound: "house",
          to_bound: "house"
        }
      },
      suggetionList: [],
      boost: {
        region: null,
        area: "region",
        city: ["area", "region"],
        settlement: ["area", "region"],
        street: ["city", "settlement"],
        house: "street"
      }
    };
  },
  computed: {
    localSuggest: {
      get() {
        return this.suggest;
      },
      set(value) {
        this.$emit("onChangeInput", [value, this.suggestKey]);
      }
    }
  },
  methods: {
    ...mapActions(["getSuggetionDaData"]),
    onClickSuggetion(suggest) {
      this.showAutocomplete = false;
      let value = "";
      if (this.suggestKey.length > 0 || this.additionalKey.length > 0) {
        value =
          suggest.data[`${this.suggestKey}_with_type`] ||
          suggest.data[`${this.additionalKey}_with_type`];
        value = value || suggest.data[`${this.suggestKey}`];
      } else {
        value = suggest.unrestricted_value;
      }
      this.$emit("onChangeInput", [value, this.suggestKey, suggest]);
    },
    onBlurInput() {
      this.showAutocomplete = false;
    },
    keyUpInput(e) {
      this.keymonitor();
      clearInterval(this.interval);
      const value = e.target.value;
      const suggestType = this.suggestType;
      let locationBoost = "";
      const location = {};
      this.interval = setInterval(() => {
        if (
          this.boost[this.suggestKey] &&
          this.boost[this.suggestKey].length === 2
        ) {
          if (this.locationBoost[`${this.boost[this.suggestKey][0]}_fias_id`]) {
            locationBoost = this.locationBoost[
              `${this.boost[this.suggestKey][0]}_fias_id`
            ];
            location[
              `${this.boost[this.suggestKey][0]}_fias_id`
            ] = locationBoost;
          } else {
            locationBoost = this.locationBoost[
              `${this.boost[this.suggestKey][1]}_fias_id`
            ];
            location[
              `${this.boost[this.suggestKey][1]}_fias_id`
            ] = locationBoost;
          }
          locationBoost =
            this.locationBoost[`${this.boost[this.suggestKey][0]}_fias_id`] ||
            this.locationBoost[`${this.boost[this.suggestKey][1]}_fias_id`];
        } else {
          locationBoost = this.locationBoost[
            `${this.boost[this.suggestKey]}_fias_id`
          ];
          location[`${this.boost[this.suggestKey]}_fias_id`] = locationBoost;
        }
        const params = {
          count: 5,
          query: `${this.paramsBoost} ${value}`,
          locations: [location]
        };
        if (suggestType.length > 0) {
          params.from_bound = {
            value: this.types[suggestType].from_bound
          };
          params.to_bound = {
            value: this.types[suggestType].to_bound
          };
        }
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.suggetionList = suggetion.data.suggestions;
          this.showAutocomplete = true;
        });
        clearInterval(this.interval);
      }, 500);
    }
  },
  mounted() {}
};
</script>
